import { render, staticRenderFns } from "./vipCode8-24.vue?vue&type=template&id=f87f9eda&scoped=true&"
import script from "./vipCode8-24.vue?vue&type=script&lang=ts&"
export * from "./vipCode8-24.vue?vue&type=script&lang=ts&"
import style0 from "./vipCode8-24.vue?vue&type=style&index=0&id=f87f9eda&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f87f9eda",
  null
  
)

export default component.exports